import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import Hero from '../Layouts/Hero';

import CourseFilteration from './CourseFilteration';
import EndSection from './EndSection';
import OneistoxLearner from './OneistoxLearner';

const Community = ({ data }) => {
  const router = useRouter();

  const { oneistoxLearner, HeroData } = data;

  const [filteredData, setFilteredData] = useState();

  const applyFilter = (oneistoxLearner, cohort) => {
    let filteredLearnersData = oneistoxLearner.learners;

    if (cohort && cohort !== 'All') {
      filteredLearnersData = filteredLearnersData?.filter((data) => {
        return data.details.cohort === cohort;
      });
    }

    return filteredLearnersData;
  };

  useEffect(() => {
    if (router.isReady) {
      const queryTag = router.query.cohort;
      setFilteredData(applyFilter(oneistoxLearner, queryTag));
    }
  }, [router.query]);

  return (
    <>
      <Hero data={HeroData} />
      <CourseFilteration />
      <OneistoxLearner
        learners={filteredData}
        heading={{ title: oneistoxLearner.title, sub: oneistoxLearner.sub }}
      />
      <EndSection />
    </>
  );
};

export default Community;
